import React from 'react'
import $ from 'jquery';
import '../Styles/Alliances.css'
import AlliancesImg from "../assets/images/our-alliances-authorized-logo.jpg"
import Footer from '../Components/Footer'
import Navbar from '../Components/Navbar'
import HappyClients from '../Components/HappyClients'
import BottomCarousel from '../Components/BottomCarousel'


function Alliances() {
  $(document).ready(function(){
    $('.customer_carousel2').owlCarousel({
      loop:true,
      margin:0,
      
      autoplay:true,
      autoplayTimeout:3000,
      autoplayHoverPause:true,
      nav:false,
      dots:true,
      responsive:{
          0:{
              items:1
          },
          320:{
              items:1
          },
          480:{
              items:1
          },
          600:{
              items:1
          },
          767:{
              items:1
          },
          991:{
              items:1
          },
          1200:{
              items:2
          }
      }
  });
  });	
$(document).ready(function(){
$('.owl-carousel').owlCarousel({
items: 10, // Number of items visible at once
loop: true, // Loop the carousel
margin: 10, // Space between items
autoplay: true, // Autoplay the carousel
autoplayTimeout: 3000, // Autoplay interval in milliseconds
responsive: {
0: {
items: 1
},
768: {
items: 2
},
1024: {
items: 4
}
}
});
});
return (
<div className="App">
<header className="header">
    
      <section className='backgroung-image-alliances'>
       <Navbar/>
      <div className='header-about-content'>
         <h1>A VENTUTE WITH OUR PARTNRES</h1>
      </div>
      </section>
   </header>
   <main className="main">
        <section className='containers about-success'>
             <div className='about-success-work'>
             <h2 className="what-we-dosss"><span className="what-we-dossss">OUR</span> ALLIANCES</h2>
             <hr className='hear-underline'></hr>
             <div className="innerContent">
                <div className="ourAllienceOutses">
                     <div className="container">
                          <div className="ourAllienceContents">
                              <img src={AlliancesImg}/></div>
                         </div>
                      </div>
                </div>
             </div>
        </section>
      {/* Happy Clients Start */}
      <section className='Happy-clients'>
          <HappyClients/>
       </section>
      {/* Happy Clients END */}
    {/* Brand Section Start */}
    <BottomCarousel/>
      {/* Brand Section end */}
   </main>
   {/* <!------footer start--------> */}
   <Footer/>
{/* <!------footer end--------> */}
</div>
);
}
export default Alliances;